<template>
  <Teleport to="body">
    <div
      v-if="show"
      class="tw-fixed tw-inset-0 tw-z-50 tw-overflow-y-auto"
    >
      <div class="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-p-4">
        <div
          class="tw-fixed tw-inset-0 tw-bg-slate-900 tw-bg-opacity-60 tw-transition-opacity"
          @click="$emit('close')"
        />
        <div class="tw-relative tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-max-w-md tw-w-full tw-p-6 md:tw-p-8">
          <div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
            <div>
              <h3 class="tw-text-lg tw-font-semibold tw-text-slate-900">
                Need it sooner?
              </h3>
              <p class="tw-mt-1 tw-text-sm tw-text-slate-600">
                Tell us the latest date you can accept delivery and we'll see what we can do to help.
              </p>
            </div>
            <button
              type="button"
              class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-slate-100 tw-text-slate-600 tw-h-9 tw-w-9 hover:tw-bg-slate-200"
              aria-label="Close need-it-sooner modal"
              @click="$emit('close')"
            >
              <span class="tw-text-lg">×</span>
            </button>
          </div>

          <form
            class="tw-mt-5 tw-space-y-4"
            @submit.prevent="handleSubmit"
          >
            <div>
              <label
                for="required-by"
                class="tw-block tw-text-sm tw-font-medium tw-text-slate-700"
              >
                Required delivery date
              </label>
              <input
                id="required-by"
                v-model="localRequiredDate"
                type="date"
                class="tw-mt-1 tw-block tw-w-full tw-rounded-md tw-border tw-border-slate-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-border-blue-500 focus:tw-ring-blue-500"
                required
              >
              <p
                v-if="error"
                class="tw-mt-2 tw-text-xs tw-text-red-600"
              >
                {{ error }}
              </p>
            </div>

            <div class="tw-flex tw-justify-end tw-gap-3">
              <button
                type="button"
                class="tw-inline-flex tw-justify-center tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-700 hover:tw-bg-slate-50"
                @click="$emit('close')"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="tw-inline-flex tw-justify-center tw-rounded-md tw-border tw-border-transparent tw-bg-emerald-600 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-shadow-sm hover:tw-bg-emerald-700 disabled:tw-opacity-60"
              >
                Send via WhatsApp
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { ref, watch } from 'vue'

export default {
  name: 'ExpediteModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    requiredDate: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'submit', 'update:requiredDate'],
  setup(props, { emit }) {
    const localRequiredDate = ref(props.requiredDate)

    watch(() => props.requiredDate, (val) => {
      localRequiredDate.value = val
    })

    watch(localRequiredDate, (val) => {
      emit('update:requiredDate', val)
    })

    const handleSubmit = () => {
      emit('submit', localRequiredDate.value)
    }

    return {
      localRequiredDate,
      handleSubmit
    }
  }
}
</script>
